module.exports = __webpack_public_path__ + "img/KUT.feb247e0.png";